export enum ResourceAbort {
  timeout = 'timeout',
  network = 'network',
}
